import React from 'react';
import { ProcedureCodeUploadTemplate } from 'themes/application/procedure-code/pages';
import { observer } from 'mobx-react';
import { ProcedureCodeUploadViewStore } from 'application/procedure-code/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore) => new ProcedureCodeUploadViewStore(rootStore), 'procedureCodeUploadViewStore')
@observer
class ProcedureCodeUpload extends React.Component {
    render() {
        return <ProcedureCodeUploadTemplate {...this.props} />
    }
}

export default ProcedureCodeUpload;